<div class="m-5" style="text-align: center;">
    <div class="d-flex">
        <i class="material-icons iconDesign mr-3">
            emoji_people
            </i>
        <h2>Fale com o Grupo Giacomini!</h2>
    </div>
</div>